var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 3.85342C9.24518 2.81027 10.7559 2.81017 11.376 3.85342L16.7178 12.8427C17.3516 13.9092 16.5824 15.2607 15.3418 15.2607H4.6582C3.41768 15.2605 2.64943 13.9092 3.2832 12.8427L8.625 3.85342ZM10.0352 11.0556C9.27333 11.0557 8.65527 11.6553 8.65527 12.3954C8.65545 13.1354 9.27344 13.7352 10.0352 13.7353C10.7968 13.7351 11.4139 13.1354 11.4141 12.3954C11.4141 11.6553 10.7969 11.0557 10.0352 11.0556ZM10.0352 5.87979C9.46399 5.88009 9.00098 6.34371 9.00098 6.91495V9.35049C9.00114 9.92159 9.46409 10.3854 10.0352 10.3857C10.6065 10.3857 11.0701 9.92178 11.0703 9.35049V6.91495C11.0703 6.34352 10.6066 5.87979 10.0352 5.87979Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWarn);
export default __webpack_public_path__ + "static/media/whiteWarn.3a86d5f952b029f0aedf21de1b86879d.svg";
export { ForwardRef as ReactComponent };